import { envInfo } from '@/constants/envInfo'

/**
 * 下载Excel模版
 * @param {String} type 模版类型
 * @param {String} rootPath 下载根路径,跨站下载
 */
export function downTemplate(type, rootPath) {
    let downTag = document.createElement('a');
    downTag.download = ""
    downTag.href = rootPath+"/param/excel/download?dlType=ExcelTemplate&excelType="+type;
    downTag.click();
}

/**
 * 下载文档中心文件
 * @param {string|number} fid 文件ID
 */
export function downFile(fid) {
    let downTag = document.createElement('a');
    downTag.download = ""
    downTag.href = envInfo.bgApp.archivePath+"/param/archive/download?dlType=DefaultDownload&fi="+fid;
    downTag.click();
}

/**
 * 下载EXCEL文件
 * @param {string | number} excelId excel文件ID
 * @param {string} flag "IMP":导入文件, "EXP":导出文件, "ERR":错误提示
 */
export function downExcel(excelId, flag, rootPath) {
    let downTag = document.createElement('a');
    downTag.download = ""
    downTag.href = rootPath+"/param/excel/download?dlType=Excel&excelFlag="+flag+"&excelId="+excelId;
    downTag.click();
}
